export default __webpack_public_path__ + "static/media/testi-user-1.a582aa74.jpg";